import { OutboxSummary } from '../../../../../services/eventingApi';
import { inputClass } from '../shared/ui';

interface SourceServiceSelectProps {
  services: OutboxSummary[];
  value: string;
  onChange: (value: string) => void;
}

const SourceServiceSelect = ({ services, value, onChange }: SourceServiceSelectProps) => (
  <select aria-label="Serviço" className={inputClass} value={value} onChange={(change) => onChange(change.target.value)}>
    <option value="">Todos os serviços</option>
    {services.map((row) => (
      <option key={row.sourceService} value={row.sourceService}>
        {row.sourceService} ({row.pending})
      </option>
    ))}
  </select>
);

export default SourceServiceSelect;
